/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unescaped-entities */
import { useEffect, useRef, useState } from 'react';
import { Navbar, Container, Nav, NavDropdown, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { SectionHeading } from '../../Components/SectionHeading';
import { RightArrowWithBorder } from '../../Components/icons';
import HeaderLogo from '../../Components/logos/HeaderLogo';
import {
  AnchorLink,
  LoginDropdownBtn,
  SimpleButton
} from '../../Components/button';
import SlideSearchIcon from '../../Components/slideSearchIcon/SlideSearchIcon';
import searchIcon from '../../assets/images/svg/search-icon-small.svg';
import './navbar.css';

function Navabrr() {
  const [stickyClass, setStickyClass] = useState('relative');
  const myRef = useRef(null);
  const addClass = useRef(null);

  const stickNavbar = () => {
    if (window !== undefined) {
      const windowHeight = window.scrollY;
      windowHeight > 50 ? setStickyClass('active2') : setStickyClass('wait');
    }
  };

  const dropDownHandler = (event) => {
    if (window.screen.width < 768) {
      if (event === true) {
        myRef.current.style.height = '100vh';
        myRef.current.style.overflow = 'auto';
      } else {
        myRef.current.style.height = 'auto';
      }
    }
  };

  const toggleHandler = (event) => {
    if (event === true) {
      addClass.current.classList.add('bg-white');
    } else {
      addClass.current.classList.remove('bg-white');
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', stickNavbar);
    return () => {
      window.removeEventListener('scroll', stickNavbar);
    };
  }, []);

  const navigate = useNavigate();

  const handleLoginNavigation = () => {
    navigate('/preLogin', { replace: true });
  };

  return (
    <section id="navbar">
      <Navbar
        expand="lg"
        onToggle={(event) => toggleHandler(event)}
        className={`stickyNavbar ${stickyClass}`}
        ref={myRef}
      >
        <Container ref={addClass}>
          <Link to="/">
            <HeaderLogo />
          </Link>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            className="x navbar-toggle"
          >
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <NavDropdown
                title="Sehat A to Z"
                renderMenuOnMount
                id="megaMenuDropDown"
                onToggle={(event) => dropDownHandler(event)}
              >
                <Container>
                  <Row>
                    <Col md={4}>
                      <SectionHeading
                        heading="Featured"
                        icon={<RightArrowWithBorder />}
                        link={<AnchorLink to="/" text="all" />}
                      />
                      <ul className="mega_menu">
                        <li>
                          <Link to="/sehatatoz">Breast Cancer</Link>
                        </li>
                        <li>
                          <Link to="/">IBD</Link>
                        </li>
                        <li>
                          <Link to="/">Migraine</Link>
                        </li>
                        <li>
                          <Link to="/">Multiple Sclerosis (MS)</Link>
                        </li>
                        <li>
                          <Link to="/">Rheumatoid Arthritis</Link>
                        </li>
                        <li>
                          <Link to="/">Type 2 Diabetes</Link>
                        </li>
                        <li>
                          <Link to="/">Sponsored Topics</Link>
                        </li>
                      </ul>
                    </Col>
                    <Col md={8}>
                      <SectionHeading
                        heading="Articles"
                        icon={<RightArrowWithBorder />}
                        link={<AnchorLink to="/" text="all" />}
                      />
                      <Row>
                        <Col md={4}>
                          <ul className="mega_menu">
                            <li>
                              <Link to="/">Acid Reflux</Link>
                            </li>
                            <li>
                              <Link to="/">ADHD</Link>
                            </li>
                            <li>
                              <Link to="/">Allergies</Link>
                            </li>
                            <li>
                              <Link to="/">Alzheimer's & Dementia</Link>
                            </li>
                            <li>
                              <Link to="/">Bipolar Disorder</Link>
                            </li>
                            <li>
                              <Link to="/">Cancer</Link>
                            </li>
                            <li>
                              <Link to="/">Crohn's Disease</Link>
                            </li>
                          </ul>
                        </Col>
                        <Col md={4}>
                          <ul className="mega_menu">
                            <li>
                              <Link to="/">Chronic Pain</Link>
                            </li>
                            <li>
                              <Link to="/">Cold & Flu</Link>
                            </li>
                            <li>
                              <Link to="/">COPD</Link>
                            </li>
                            <li>
                              <Link to="/">Multiple</Link>
                            </li>
                            <li>
                              <Link to="/">Fibromyalgia</Link>
                            </li>
                            <li>
                              <Link to="/">Heart Disease</Link>
                            </li>
                            <li>
                              <Link to="/">High Cholesterol</Link>
                            </li>
                          </ul>
                        </Col>
                        <Col md={4}>
                          <ul className="mega_menu">
                            <li>
                              <Link to="/">HIV</Link>
                            </li>
                            <li>
                              <Link to="/">Hypertension</Link>
                            </li>
                            <li>
                              <Link to="/">IPF</Link>
                            </li>
                            <li>
                              <Link to="/">Osteoarthritis</Link>
                            </li>
                            <li>
                              <Link to="/">Psoriasis</Link>
                            </li>
                            <li>
                              <Link to="/">Skin Disorders and Care</Link>
                            </li>
                            <li>
                              <Link to="/">STDs</Link>
                            </li>
                          </ul>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </NavDropdown>
              <Link to="/healthCheck">HealthCheck</Link>
              <Link to="/findADoctor">Find a Doctor</Link>
              <Link to="/discoverWellness">Discover Wellness</Link>
            </Nav>
            <SlideSearchIcon icon={searchIcon} />
            <SimpleButton onClick={handleLoginNavigation} text="login" />
            <LoginDropdownBtn title="AB" />
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </section>
  );
}

export default Navabrr;
